import type { PrintDocumentFieldValue } from '../types';
import { printLabelsFor, type DocumentLocaleCode } from '../printLabels';

interface OrderFormFieldValuesTableProps {
  values: ReadonlyArray<PrintDocumentFieldValue> | null | undefined;
  locale: DocumentLocaleCode;
}

/**
 * [233] 주문서 추가정보(통관 등 custom order-form field 값) 표 — 거래명세서/주문내역서 공통.
 *
 * 해외 배송에 필수인 추가정보가 종전 문서 경로에서 누락돼 표시되지 않았다(BO 주문상세엔
 * OrderFormFieldValuesSection 으로 노출되나 출력물엔 빠짐) → 두 문서 하단에 동봉한다.
 * 값이 없으면(국내/미입력 주문) 섹션 자체를 그리지 않아 빈 표 노이즈를 막는다.
 * 라벨/마스킹 배지는 주문 발생 몰 locale 기준(문서 i18n 정합). masked=true 면 value 가
 * 이미 마스킹된 표시값(BE 가공).
 */
export const OrderFormFieldValuesTable = ({
  values,
  locale,
}: OrderFormFieldValuesTableProps) => {
  if (!values || values.length === 0) return null;
  const labels = printLabelsFor(locale).orderFormFieldValues;
  return (
    <table style={{ marginTop: 12 }}>
      <thead>
        <tr>
          <th colSpan={2}>{labels.title}</th>
        </tr>
      </thead>
      <tbody>
        {values.map((v, idx) => (
          <tr key={`${v.label}-${idx}`}>
            <th style={{ width: '30%' }}>{v.label}</th>
            <td>
              {v.value || '-'}
              {v.masked ? (
                <span style={{ marginLeft: 6, fontSize: 11, color: '#666' }}>
                  ({labels.maskedBadge})
                </span>
              ) : null}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
